import React from "react"
import { Link } from "react-router-dom"
import React from "react"

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-orange-500">MULE</span>
              <span className="text-white">SHED</span>
            </div>
            <p className="text-gray-400 text-sm">
              Professional mule shed and shed moving equipment for portable building movers and haulers.
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Home
              </Link>
              <Link to="/products" className="block text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Products
              </Link>
              <Link to="/blog" className="block text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Blog
              </Link>
              <Link to="/privacy" className="block text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/contact" className="block text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Services</h3>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>Shed Moving Equipment</p>
              <p>New & Used Mule Sales</p>
              <p>Mule Shed Delivery</p>
              <p>Equipment Financing</p>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Disclaimer</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              MuleShed.com is not affiliated with, sponsored by, or endorsed by Cardinal Manufacturing LLC. "The Mule" is a registered trademark of its respective owner.
            </p>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} MuleShed.com. All rights reserved. Informational resource for shed moving equipment and machinery.</p>
          <p className="mt-2 text-xs text-gray-600">This website is an informational resource and not affiliated with any equipment manufacturer.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
